export default __webpack_public_path__ + "psn-inner.d34dc2e41a0566732cc3ee596bb95a5c.css";